<template>
  <!-- <el-menu class="menu" mode="horizontal" background-color="" :default-active="activeIndex" :router="true"
    :text-color="attr ? '#fff' : '#333333'" :active-text-color="attr ? '#ff5715' : '#333333'">
    <el-menu-item v-for="(item, index) in menuList" :key="index" :index="item.path" @click="cc(item.title)">{{
      item.title }}</el-menu-item>
  </el-menu> -->
  <div class="nav-bar-mobile-menu">
    <ul class="flex flex-wrap menu-ul">
      <li v-for="(item, index) in menuList" :key="index" @click="cc(item)"
        :class="[(item.path === '/' ? nowPath === '/' : nowPath.startsWith(item.path)) ? 'active-navbar' : '', 'flex-11t']">
        {{ item.title }}
      </li>
      <!-- <li class="flex-11t">
        <span v-for="(item, index) in languageColumns" :key="index" @click="setLang(item.value)"
          :class="[$i18n.locale == item.value ? 'active-navbar' : '']">{{ item.text }}</span>
      </li> -->
    </ul>
    <!-- <div class="navbar-lang">
      <span v-for="(item, index) in languageColumns" :key="index">{{ item.text }}</span>
    </div> -->
  </div>
</template>

<script>
// import { navbar } from "../common";
// import { languageColumns } from '../../locale/utils'
import { setNowRoute } from '../../js/nowRoute'
export default {
  name: "Menu",
  props: {
    attr: Boolean,
    menuList: {
      type: Array,
      default: []
    }
  },
  computed: {
    activeIndex() {
      return this.$route.meta.active || this.$route.path;
    },
  },
  watch: {
    $route(val) {
      setNowRoute(val.name)
      this.nowPath = val.meta.active || val.path
    },
  },
  data() {
    return {
      nowPath: '/',
      // languageColumns: languageColumns
    };
  },
  mounted() {
    this.nowPath = this.$route.meta.active || this.$route.path
  },
  methods: {

    // setLang(item) {
    //   if (!item) return
    //   this.$i18n.locale = item
    //   localStorage.setItem('333f-locale-lang', item)
    //   location.reload()
    // },
    handleMouseEnter() {
      this.isHovered = true;
    },
    handleMouseLeave() {
      this.isHovered = false;
    },
    cc(n) {
      this.$emit("closeMobile", false);
      if (n.title == "川云" || n.title == "chuanyun" || n.title == "Chuanyun") {
        window.open("https://cy.idea888.com/?tag=333f");
      } else {
        this.$router.push(n.path)
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nav-bar-mobile-menu {
  background: rgba(0, 0, 0, .8);
  /* background: radial-gradient(black, #656565); */
  backdrop-filter: saturate(180%) blur(10px);
  width: 100%;
  height: calc(100vh - 80px);
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  z-index: 1002;
  color: #fff;
  text-align: center;
  /* line-height: 50px; */
  font-size: 30px;
  letter-spacing: 4px;

  .menu-ul {}
}

.nav-bar-mobile-menu ul li {
  padding: 30px 0;
}

.nav-bar-mobile-menu .active-navbar {
  /* height: 70px; */
  /* border-bottom: 4px solid #ff5715; */
  color: @primaryColor;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar/MenuMobile.vue